module.exports = __webpack_public_path__ + "static/media/Careem_Rebranded_Logo.bca15337.svg";